// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// HACK: disobeys folder structure rules
import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';

// Local Constants
import { myTimesheetEntryFields } from './constants';

const selectMyTimesheetsLoadParams = createDeepEqualSelector(
    [selectCurrentOrganizationId, selectFirstDate, selectLastDate],
    (
        currentOrganizationIdState: string | undefined,
        firstDateState: string,
        lastDateState: string
        // @ts-ignore
    ) => ({
        organizationId: currentOrganizationIdState,
        filter: {
            require: {
                deletedAt: { $exists: false },
                versionedAt: { $exists: false },
                $or: [
                    // Request all entries for the week currently being viewed
                    {
                        date: {
                            $gte: firstDateState,
                            $lte: lastDateState
                        }
                    },
                    // Request all unapproved entries
                    {
                        lastReviewIsApproved: { $exists: false }
                    }
                ]
            },
            fields: myTimesheetEntryFields
        }
    })
);

export { selectMyTimesheetsLoadParams };
